import { Params } from '@angular/router';

export type MenuItemType = {
  key: string;
  label: string;
  isTitle?: boolean;
  isSuperAdmin?: boolean;
  icon?: string;
  url?: string;
  queryParams?: Params;
  badge?: {
    variant: string;
    text: string;
  };
  parentKey?: string;
  isDisabled?: boolean;
  collapsed?: boolean;
  children?: MenuItemType[];

};

export type SubMenus = {
  item: MenuItemType;
  linkClassName?: string;
  subMenuClassName?: string;
  activeMenuItems?: Array<string>;
  toggleMenu?: (item: MenuItemType, status: boolean) => void;
  className?: string;
};

const APP_MENU_ITEMS: MenuItemType[] = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    icon: 'ti ti-category-2',
    url: '/pages/dashboard',
  },
  {
    key: 'timesheet',
    label: 'Timesheet',
    icon: 'ti ti-calendar',
    url: '/pages/timesheet',
  },
  {
    key: 'customer',
    label: 'Customer',
    icon: 'ti ti-user-shield',
    url: '/pages/customer',
  },

  {
    key: 'property',
    label: 'Property',
    icon: 'ri-home-gear-line',
    url: '/pages/property',
  },
  {
    icon: 'ti ti-car-garage',
    key: 'parking-management',
    label: 'Parking Management',
    url: '/pages/parking-management',
  },
  {
    key: 'human-resource',
    label: 'Human Resource',
    isTitle: true,
  },
  {
    key: 'user',
    label: 'Employee',
    icon: 'ti ti-user-square-rounded',
    url: '/pages/users',
  },
  {
    icon: 'ti ti-plane-tilt',
    key: 'holiday',
    label: 'Public Holiday',
    url: '/pages/holiday',
  },
  {
    key: 'afp-jobs-title',
    label: 'Afp Jobs',
    isTitle: true,
  },
  {
    key: 'afp-jobs',
    label: 'AFP Jobs',
    icon: 'ri-file-list-2-line',
    url: '/pages/afp-jobs',
  },
  {
    key: 'afp-batches',
    label: 'AFP Batches',
    icon: 'ri-file-copy-2-line',
    url: '/pages/afp-batches',
  },
  {
    key: 'afp-collections',
    label: 'AFP Collections',
    icon: 'ri-file-copy-2-line',
    url: '/pages/afp-collections',
  },
  {
    key: 'report-title',
    label: 'Reports',
    isTitle: true,
  },
  {
    key: 'timesheet-report',
    label: 'Timesheet Report',
    icon: 'ti ti-calendar-month',
    url: '/pages/timesheet-report',
  },
  {
    key: 'report',
    label: 'Labour Report',
    icon: 'ti ti-clipboard-list',
    url: '/pages/report',
  },
  {
    key: 'afp-reports',
    label: 'AFP Reports',
    icon: 'ri-file-copy-2-line',
    url: '/pages/afp-reports',
  },
  {
    key: 'afp-batch-reports',
    label: 'AFP Batch Reports',
    icon: 'ri-file-copy-2-line',
    url: '/pages/afp-batch-reports',
  },
  {
    key: 'rebillable-reports',
    label: 'Rebillable Reports',
    icon: 'ri-file-copy-2-line',
    url: '/pages/rebillable-reports',
  },
  {
    key: 'report-nrt',
    label: 'NRT Report',
    icon: 'ti ti-report',
    url: '/pages/nrt-report',
  },
  {
    key: 'powerbi-analytics',
    label: 'AFP Analytics',
    icon: 'ri-file-copy-2-line',
    url: '/pages/afp-analyitcs',
    isSuperAdmin: true,
  },
  // Removed duplicate Health Check section
  {
    key: 'fleet',
    label: 'Fleet',
    isTitle: true,
  },
  {
    icon: 'ti ti-car',
    key: 'fleet-vehicle',
    label: 'Vehicle',
    url: '/pages/vehicle',
  },
  {
    icon: 'ti ti-car-garage',
    key: 'daily-vehicle-check',
    label: 'Daily Vehicle Check',
    url: '/pages/daily-vehicle-check',
  },
  {
    key: 'ticksheet',
    label: 'Ticksheet',
    isTitle: true,
  },
  {
    key: 'ticksheet-form',
    label: 'Ticksheet Forms',
    url: '/pages/ticksheet-form',
    icon: 'ti ti-file-analytics',
  },
  {
    key: 'ticksheets',
    label: 'Ticksheet',
    url: '/pages/ticksheets',
    icon: 'ti ti-checkup-list',
  },
  {
    key: 'health-check-title',
    label: 'Health Check',
    isTitle: true,
  },
  {
    key: 'health-check',
    label: 'Health and Safety',
    icon: 'ti ti-heart-rate-monitor',
    url: '/health-check',
  },
  {
    key: 'submissions',
    label: 'Submissions',
    icon: 'ti ti-folder',
    url: '/pages/submissions',
  },
  {
    key: 'health-check-folders',
    label: 'Folders',
    icon: 'ti ti-folder',
    collapsed: true,
    children: [], // Will be populated dynamically
  },
  {
    key: 'inventory',
    label: 'Inventory',
    isTitle: true,
  },
  {
    key: 'it-assets',
    label: 'IT Assets',
    url: '/inventory/it-assets',
    icon: 'ti ti-device-laptop',
  },
  {
    key: 'configuration',
    label: 'Configuration',
    isTitle: true,
  },
  {
    key: 'leave-type',
    label: 'Holiday',
    icon: 'ti ti-luggage',
    url: '/configuration/holiday-job-number',
  },
  {
    key: 'company',
    label: 'Company',
    icon: 'ri-community-line',
    url: '/pages/company',
  },
  {
    key: 'department',
    label: 'Department',
    icon: 'ri-organization-chart',
    url: '/pages/department',
  },
  {
    key: 'vehicle-config',
    label: 'Vehicle',
    url: '/configuration/vehicle',
    icon: 'ti ti-truck',
  },
  {
    key: 'dvc',
    label: 'Vehicle Checklist',
    url: '/configuration/vehicle-checklist',
    icon: 'ti ti-list-check',
  },
  {
    key: 'itAssets',
    label: 'IT Assets',
    url: '/configuration/it-assets',
    icon: 'ti ti-device-laptop',
  },
  {
    key: 'parking-management-configuration',
    label: 'Parking management',
    url: '/configuration/parking-management-configuration',
    icon: 'ti ti-car-garage',
  },
  {
    key: 'document-type',
    label: 'Document Type',
    url: '/configuration/document-type',
    icon: 'ti ti-file-lambda',
  },
  {
    key: 'sor',
    label: 'SOR',
    url: '/configuration/sor',
    icon: 'ri-file-code-line',
  },
];

const FILESHARE_MENU_ITEMS: MenuItemType[] = [
  {
    key: 'files-sharing',
    label: 'File Sharing',
    isTitle: true,
  },
  {
    key: 'file-sharing',
    label: 'My Files',
    url: '/pages/file-sharing',
    icon: 'ti ti-share',
  },
  {
    key: 'shared-with-me',
    label: 'Shared With Me',
    url: '/pages/shared-with-me',
    icon: 'ti ti-user-share',
  },
  {
    key: 'shared-links',
    label: 'Shared Links',
    url: '/pages/shared-links',
    icon: 'ti ti-link',
  },
  {
    key: 'activity-log',
    label: 'Activity Log',
    url: '/pages/activity-log',
    icon: 'ti ti-activity',
  },
  //  {
  //   key: 'recent-files',
  //   label: 'Recent Files',
  //   url: '/pages/recent-files',
  //   icon: 'ti ti-clock',
  // },
]

const FILESHARE_ADMIN_MENU_ITEMS: MenuItemType[] = [
  {
    key: 'files-sharing-admin',
    label: 'File Sharing Admin',
    isTitle: true,
  },
  {
    key: 'fs-admin-manage-company',
    label: 'Manage Companies',
    url: '/pages/file-sharing/manage-companies',
    icon: 'ri ri-building-line',
  },
  {
    key: 'fs-admin-manage-users',
    label: 'Manage Users',
    url: '/pages/file-sharing/manage-users',
    icon: 'ri ri-group-line',
  },
]
// Backend User Model: 
// FileShare Role -> ONE-MASTER, ONE-VIEWER, CUSTOMER-MASTER, CUSTOMER-VIEWER -> [FILE_SHARE_ROLE_ID]
// 
import { EmployeeProfile } from '@core/interface/employee';

/**
 * Get menu items based on user profile
 * @param profile - User profile from state (optional, defaults to null)
 * @returns Array of menu items
 */
export function getMenuItems(profile: EmployeeProfile | null = null): MenuItemType[] {
  // Always show all app menu items (including Submissions)
  let PROCESSED_MENU_ITEMS: MenuItemType[] = [...APP_MENU_ITEMS];

  // Optionally, add file sharing menu items if file sharing is enabled
  // const fileShareEnabled = profile?.file_sharing_role !== null && profile?.file_sharing_role !== undefined;
  // const fileShareRole: string = profile?.file_sharing_role?.name || '';
  // if (fileShareEnabled) {
  //   PROCESSED_MENU_ITEMS = PROCESSED_MENU_ITEMS.concat(FILESHARE_MENU_ITEMS);
  //   if (fileShareRole === 'ONE_MASTER') {
  //     PROCESSED_MENU_ITEMS = PROCESSED_MENU_ITEMS.concat(FILESHARE_ADMIN_MENU_ITEMS);
  //   }
  // }

  return PROCESSED_MENU_ITEMS;
}

// Default export for backward compatibility (will be empty if no profile)
export const MENU_ITEMS: MenuItemType[] = [];

export const HORIZONTAL_MENU_ITEM: MenuItemType[] = [
  {
    key: 'dashboards',
    label: 'Dashboards',
    icon: 'ti-dashboard',
    url: '/index',
  },
  {
    key: 'apps',
    label: 'Apps',
    icon: 'ti-apps',
    children: [
      {
        key: 'chat',
        label: 'Chat',
        icon: 'ti-message',
        url: '/apps/chat',
        parentKey: 'apps',
      },
      {
        key: 'calendar',
        label: 'Calendar',
        icon: 'ti-calendar',
        url: '/apps/calendar',
        parentKey: 'apps',
      },
      {
        key: 'email',
        label: 'Email',
        icon: 'ti-inbox',
        url: '/apps/email',
        parentKey: 'apps',
      },
      {
        key: 'file-manager',
        label: 'File Manager',
        icon: 'ti-folder',
        url: '/apps/file-manager',
        parentKey: 'apps',
      },
      {
        key: 'users',
        label: 'Users',
        icon: 'ti-user-square-rounded',
        parentKey: 'apps',
        children: [
          {
            key: 'contacts',
            label: 'Contacts',
            url: '/apps/user-contact',
            parentKey: 'users',
          },
          {
            key: 'profile',
            label: 'Profile',
            url: '/apps/user-profile',
            parentKey: 'users',
          },
        ],
      },
      {
        key: 'project',
        label: 'Projects',
        icon: 'ti-briefcase',
        url: '/apps/projects',
        parentKey: 'apps',
      },
      {
        key: 'tasks',
        label: 'Tasks',
        icon: 'ti-layout-kanban',
        parentKey: 'apps',
        children: [
          {
            key: 'kanban',
            label: 'Kanban',
            url: '/apps/kanban',
            parentKey: 'tasks',
          },
          {
            key: 'detail',
            label: 'View Detail',
            url: '/apps/task-detail',
            parentKey: 'tasks',
          },
        ],
      },
      {
        key: 'invoice',
        label: 'Invoice',
        parentKey: 'apps',
        children: [
          {
            key: 'invoices',
            label: 'Invoice',
            url: '/invoice/invoices',
            parentKey: 'invoice',
          },
          {
            key: 'view-invoice',
            label: 'View Invoice',
            url: '/invoice/view',
            parentKey: 'invoice',
          },
          {
            key: 'create-invoice',
            label: 'Create Invoice',
            url: '/invoice/create',
            parentKey: 'invoice',
          },
        ],
      },
    ],
  },
  {
    key: 'pages',
    label: 'Pages',
    icon: 'ti-file-description',
    children: [
      {
        key: 'auth',
        label: 'Authentication',
        parentKey: 'pages',
        children: [
          {
            key: 'login',
            label: 'Login',
            url: '/auth/login',
            parentKey: 'auth',
          },
          {
            key: 'register',
            label: 'Register',
            url: '/auth/register',
            parentKey: 'auth',
          },
          {
            key: 'logout',
            label: 'Logout',
            url: '/auth/logout',
            parentKey: 'auth',
          },
          {
            key: 'recover-password',
            label: 'Recover Password',
            url: '/auth/recover-password',
            parentKey: 'auth',
          },
          {
            key: 'create-password',
            label: 'Create Password',
            url: '/auth/create-password',
            parentKey: 'auth',
          },
          {
            key: 'lock-screen',
            label: 'Lock Screen',
            url: '/auth/lock-screen',
            parentKey: 'auth',
          },
          {
            key: 'confirm-mail',
            label: 'Confirm Mail',
            url: '/auth/confirm-mail',
            parentKey: 'auth',
          },
          {
            key: 'login-pin',
            label: 'Login with PIN',
            url: '/auth/pin-login',
            parentKey: 'auth',
          },
        ],
      },
      {
        key: 'errors',
        label: 'Error Pages',
        parentKey: 'pages',
        children: [
          {
            key: 'error-401',
            label: '401 Unauthorized',
            url: '/errors-401',
            parentKey: 'errors',
          },
          {
            key: 'error-400',
            label: '400 Bad Reques',
            url: '/error-400',
            parentKey: 'errors',
          },
          {
            key: 'error-403',
            label: '403 Forbidden',
            url: '/error-403',
            parentKey: 'errors',
          },
          {
            key: 'error-404',
            label: '404 Not Found',
            url: '/error-404',
            parentKey: 'errors',
          },
          {
            key: 'error-500',
            label: '500 Internal Server',
            url: '/error-500',
            parentKey: 'errors',
          },
          {
            key: 'service-unavailable',
            label: 'Service Unavailable',
            url: '/service-unavailable',
            parentKey: 'errors',
          },
        ],
      },
      {
        key: 'starter-page',
        label: 'Starter Page',
        url: '/pages/starter-page',
        parentKey: 'pages',
      },
      {
        key: 'pricing',
        label: 'Pricing',
        url: '/pages/pricing',
        parentKey: 'pages',
      },
      {
        key: 'faq',
        label: 'FAQ',
        url: '/pages/faq',
        parentKey: 'pages',
      },
      {
        key: 'pricing-one',
        label: 'Pricing One',
        url: '/pricing/pricing-one',
        parentKey: 'pages',
      },
      {
        key: 'pricing-two',
        label: 'Pricing Two',
        url: '/pricing/pricing-two',
        parentKey: 'pages',
      },
      {
        key: 'maintenance',
        label: 'Maintenance',
        url: 'maintenance',
        parentKey: 'pages',
      },
      {
        key: 'timeline',
        label: 'Timeline',
        url: '/pages/timeline',
        parentKey: 'pages',
      },
    ],
  },
  {
    key: 'components',
    label: 'Components',
    icon: 'ti-components',
    children: [
      {
        key: 'base-ui',
        label: 'Base UI',
        parentKey: 'components',

        children: [
          {
            key: 'base-ui-accordions',
            label: 'Accordions',
            url: '/ui/accordions',
            parentKey: 'base-ui',
          },
          {
            key: 'base-ui-alerts',
            label: 'Alerts',
            url: '/ui/alerts',
            parentKey: 'base-ui',
          },
          {
            key: 'base-ui-avatars',
            label: 'Avatars',
            url: '/ui/avatars',
            parentKey: 'base-ui',
          },
          {
            key: 'base-ui-badges',
            label: 'Badges',
            url: '/ui/badges',
            parentKey: 'base-ui',
          },
          {
            key: 'base-ui-breadcrumb',
            label: 'Breadcrumb',
            url: '/ui/breadcrumb',
            parentKey: 'base-ui',
          },
          {
            key: 'base-ui-buttons',
            label: 'Buttons',
            url: '/ui/buttons',
            parentKey: 'base-ui',
          },
          {
            key: 'base-ui-cards',
            label: 'Cards',
            url: '/ui/cards',
            parentKey: 'base-ui',
          },
          {
            key: 'base-ui-carousel',
            label: 'Carousel',
            url: '/ui/carousel',
            parentKey: 'base-ui',
          },
          {
            key: 'base-ui-collapse',
            label: 'Collapse',
            url: '/ui/collapse',
            parentKey: 'base-ui',
          },
          {
            key: 'base-ui-dropdowns',
            label: 'Dropdowns',
            url: '/ui/dropdowns',
            parentKey: 'base-ui',
          },
          {
            key: 'ul-ratio',
            label: 'Ratio',
            url: '/ui/ratio',
            parentKey: 'base-ui',
          },
          {
            key: 'ul-grid',
            label: 'Grid',
            url: '/ui/grid',
            parentKey: 'base-ui',
          },
          {
            key: 'ul-links',
            label: 'Links',
            url: '/ui/links',
            parentKey: 'base-ui',
          },
          {
            key: 'base-ui-list-group',
            label: 'List Group',
            url: '/ui/list-group',
            parentKey: 'base-ui',
          },
        ],
      },
      {
        key: 'base-ui2',
        label: 'Base UI 2',
        parentKey: 'components',
        children: [
          {
            key: 'base-ui2-modals',
            label: 'Modals',
            url: '/ui/modals',
            parentKey: 'base-ui2',
          },
          {
            key: 'base-ui2-notifications',
            label: 'Notifications',
            url: '/ui/notifications',
            parentKey: 'base-ui2',
          },
          {
            key: 'base-ui2-offcanvas',
            label: 'Offcanvas',
            url: '/ui/offcanvas',
            parentKey: 'base-ui2',
          },
          {
            key: 'base-ui2-placeholders',
            label: 'Placeholders',
            url: '/ui/placeholders',
            parentKey: 'base-ui2',
          },
          {
            key: 'base-ui2-pagination',
            label: 'Pagination',
            url: '/ui/pagination',
            parentKey: 'base-ui2',
          },
          {
            key: 'base-ui2-popovers',
            label: 'Popovers',
            url: '/ui/popovers',
            parentKey: 'base-ui2',
          },
          {
            key: 'base-ui2-progress',
            label: 'Progress',
            url: '/ui/progress',
            parentKey: 'base-ui2',
          },
          {
            key: 'base-ui2-spinners',
            label: 'Spinners',
            url: '/ui/spinners',
            parentKey: 'base-ui2',
          },
          {
            key: 'base-ui2-tabs',
            label: 'Tabs',
            url: '/ui/tabs',
            parentKey: 'base-ui2',
          },
          {
            key: 'base-ui2-tooltips',
            label: 'Tooltips',
            url: '/ui/tooltips',
            parentKey: 'base-ui2',
          },
          {
            key: 'base-ui2-typography',
            label: 'Typography',
            url: '/ui/typography',
            parentKey: 'base-ui2',
          },
          {
            key: 'base-ui2-utilities',
            label: 'Utilities',
            url: '/ui/utilities',
            parentKey: 'base-ui2',
          },
        ],
      },
      {
        key: 'extended-ui-pages',
        label: 'Extended UI',
        parentKey: 'components',
        children: [
          {
            key: 'dragula',
            label: 'Dragula',
            url: '/extended-ui/dragula',
            parentKey: 'extended-ui-pages',
          },
          {
            key: 'sweet-alert',
            label: 'Sweet Alert',
            url: '/extended-ui/sweet-alert',
            parentKey: 'extended-ui-pages',
          },
          {
            key: 'ratings',
            label: 'Ratings',
            url: '/extended-ui/ratings',
            parentKey: 'extended-ui-pages',
          },
          {
            key: 'scrollbar',
            label: 'Scrollbar',
            url: '/extended-ui/scrollbar',
            parentKey: 'extended-ui-pages',
          },
        ],
      },
      {
        key: 'forms',
        label: 'Forms',
        parentKey: 'components',
        children: [
          {
            key: 'basic',
            label: 'Basic Elements',
            url: '/form/basic-elements',
            parentKey: 'forms',
          },
          {
            key: 'inputmask',
            label: 'Inputmask',
            url: '/form/inputmask',
            parentKey: 'forms',
          },
          {
            key: 'picker',
            label: 'Picker',
            url: '/form/picker',
            parentKey: 'forms',
          },
          {
            key: 'select',
            label: 'Select',
            url: '/form/select',
            parentKey: 'forms',
          },
          {
            key: 'slider',
            label: 'Range Slider',
            url: '/form/slider',
            parentKey: 'forms',
          },
          {
            key: 'validation',
            label: 'Validation',
            url: '/form/validation',
            parentKey: 'forms',
          },
          {
            key: 'wizard',
            label: 'Wizard',
            url: '/form/wizard',
            parentKey: 'forms',
          },
          {
            key: 'file-uploads',
            label: 'File Uploads',
            url: '/form/file-uploads',
            parentKey: 'forms',
          },
          {
            key: 'editors',
            label: 'Editors',
            url: '/form/editors',
            parentKey: 'forms',
          },
          {
            key: 'layouts',
            label: 'Layouts',
            url: '/form/layouts',
            parentKey: 'forms',
          },
        ],
      },
      {
        key: 'charts',
        label: 'charts',
        parentKey: 'components',
        children: [
          {
            key: 'area',
            label: 'area',
            url: '/charts/area',
            parentKey: 'charts',
          },
          {
            key: 'bar',
            label: 'Bar',
            url: '/charts/bar',
            parentKey: 'charts',
          },
          {
            key: 'bubble',
            label: 'Bubble',
            url: '/charts/bubble',
            parentKey: 'charts',
          },
          {
            key: 'candlestick',
            label: 'Candlestick',
            url: '/charts/candlestick',
            parentKey: 'charts',
          },
          {
            key: 'column',
            label: 'Column',
            url: '/charts/column',
            parentKey: 'charts',
          },
          {
            key: 'heatmap',
            label: 'Heatmap',
            url: '/charts/heatmap',
            parentKey: 'charts',
          },
          {
            key: 'line',
            label: 'Line',
            url: '/charts/line',
            parentKey: 'charts',
          },
          {
            key: 'mixed',
            label: 'Mixed',
            url: '/charts/mixed',
            parentKey: 'charts',
          },
          {
            key: 'timeline-chart',
            label: 'Timeline',
            url: '/charts/timeline',
            parentKey: 'charts',
          },
          {
            key: 'boxplot',
            label: 'Boxplot',
            url: '/charts/boxplot',
            parentKey: 'charts',
          },
          {
            key: 'treemap',
            label: 'Treemap',
            url: '/charts/treemap',
            parentKey: 'charts',
          },
          {
            key: 'pie',
            label: 'Pie',
            url: '/charts/pie',
            parentKey: 'charts',
          },
          {
            key: 'radar',
            label: 'Radar',
            url: '/charts/radar',
            parentKey: 'charts',
          },
          {
            key: 'radialBar',
            label: 'RadialBar',
            url: '/charts/radialbar',
            parentKey: 'charts',
          },
          {
            key: 'scatter',
            label: 'Scatter',
            url: '/charts/scatter',
            parentKey: 'charts',
          },
          {
            key: 'polar',
            label: 'Polar Area',
            url: '/charts/polar',
            parentKey: 'charts',
          },
          {
            key: 'sparklines',
            label: 'Sparklines',
            url: '/charts/sparklines',
            parentKey: 'charts',
          },
        ],
      },
      {
        key: 'tables',
        label: 'Tables',
        parentKey: 'components',
        children: [
          {
            key: 'basic',
            label: 'Basic Tables',
            url: '/tables/basic-tables',
            parentKey: 'tables',
          },
          {
            key: 'gridJs',
            label: 'GridJs Tables',
            url: '/tables/datatable',
            parentKey: 'tables',
          },
        ],
      },
      {
        key: 'icons',
        label: 'Icons',
        parentKey: 'components',
        children: [
          {
            key: 'remix',
            label: 'Remix',
            url: '/icons/remix',
            parentKey: 'icons',
          },
          {
            key: 'tabler',
            label: 'Tabler',
            url: '/icons/tabler',
            parentKey: 'icons',
          },
          {
            key: 'solar',
            label: 'Solar',
            url: '/icons/solar',
            parentKey: 'icons',
          },
        ],
      },
      {
        key: 'maps',
        label: 'Maps',
        parentKey: 'components',
        children: [
          {
            key: 'google',
            label: 'Google Maps',
            url: '/maps/google',
            parentKey: 'maps',
          },
          {
            key: 'vector',
            label: 'Vector Maps',
            url: '/maps/vector',
            parentKey: 'maps',
          },
          {
            key: 'leaflet',
            label: 'Leaflet Maps',
            url: '/maps/leaflet',
            parentKey: 'maps',
          },
        ],
      },
    ],
  },
  {
    key: 'layouts',
    label: 'Layouts',
    icon: 'ti-layout',
    collapsed: true,
    children: [
      {
        key: 'horizontal',
        label: 'Horizontal',
        url: '/horizontal',
        parentKey: 'layouts',
      },
      {
        key: 'detached',
        label: 'Detached',
        url: '/detached',
        parentKey: 'layouts',
      },
      {
        key: 'full',
        label: 'Full View',
        url: '/full-view',
        parentKey: 'layouts',
      },
      {
        key: 'fullscreen',
        label: 'FullScreen View',
        url: '/fullscreen-view',
        parentKey: 'layouts',
      },
      {
        key: 'hover',
        label: 'Hover Menu',
        url: '/hover-menu',
        parentKey: 'layouts',
      },
      {
        key: 'compact',
        label: 'Compact',
        url: '/compact-menu',
        parentKey: 'layouts',
      },
      {
        key: 'icon-view',
        label: 'Icon View',
        url: '/icon-view',
        parentKey: 'layouts',
      },
    ],
  },
];
